/* global history, sessionStorage */
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

import {
    gsap,
} from 'gsap';
import {
    ScrollTrigger,
} from 'gsap/ScrollTrigger';
import {
    ScrollToPlugin,
} from 'gsap/ScrollToPlugin';
import AOS from 'aos';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener('DOMContentLoaded', () => {

    const hero = document.querySelector('.homepage-hero-section');
    const promo = document.querySelector('.capabilities-promo-section');

    let wrapper = null;
    const sectionControllers = [];

    let isResetting = false; // ✅ guard flag
    const lockScrollTrigger = false;

    // =========================
    // WRAP HERO + PROMO
    // =========================
    if (hero && promo && hero.nextElementSibling === promo) {
        wrapper = document.createElement('div');
        wrapper.classList.add('hero-promo-wrapper');

        hero.parentNode.insertBefore(wrapper, hero);
        wrapper.appendChild(hero);
        wrapper.appendChild(promo);

        const resumeAos = () => {
            hero.classList.add('aos-animate');

            if (window.AOS) {
                if (typeof AOS.refreshHard === 'function') {
                    AOS.refreshHard();
                } else if (typeof AOS.refresh === 'function') {
                    AOS.refresh();
                } else if (typeof AOS.init === 'function') {
                    AOS.init();
                }
            }
        };

        setTimeout(resumeAos, 500);
    }

    // =========================
    // MAIN SECTION LOGIC
    // =========================
    document.querySelectorAll('.capabilities-promo-section').forEach((section) => {

        const wrapper = section.closest('.hero-promo-wrapper');
        const pinTarget = wrapper || section;

        const items = section.querySelectorAll('.cps-content-item');
        const indexItems = section.querySelectorAll('.cps-index-item');
        const headingItems = section.querySelectorAll('.cps-heading-item');
        const paginationItems = section.querySelectorAll('.cps-pagination-item');

        const total = items.length;

        let currentIndex = 1;
        let isAnimating = false;
        let pendingDirection = 0;

        function setActive(index, silent = false) {
            if (index < 1 || index > total) {
                isAnimating = false;
                return;
            }

            const all = [...indexItems, ...headingItems, ...items];

            isAnimating = !silent;
            currentIndex = index;

            if (silent) {
                // ⭐ FIX: sync pagination too
                paginationItems.forEach(el => el.classList.remove('is-active'));
                const activePagination = section.querySelector(`.cps-pagination-item[data-index="${index}"]`);
                if (activePagination) {
                    activePagination.classList.add('is-active');
                }

                all.forEach(el => {
                    el.style.display = 'none';
                    el.classList.remove('is-active');
                });

                const activeIndexItem = section.querySelector(`.cps-index-item[data-index="${index}"]`);
                const activeHeadingItem = section.querySelector(`.cps-heading-item[data-index="${index}"]`);
                const activeContentItem = section.querySelector(`.cps-content-item[data-index="${index}"]`);

                activeIndexItem && (activeIndexItem.style.display = 'block');
                activeHeadingItem && (activeHeadingItem.style.display = 'block');
                activeContentItem && (activeContentItem.style.display = 'block');

                activeIndexItem ?.classList.add('is-active');
                activeHeadingItem ?.classList.add('is-active');
                activeContentItem ?.classList.add('is-active');

                return;
            }

            paginationItems.forEach(el => el.classList.remove('is-active'));
            const activePagination = section.querySelector(`.cps-pagination-item[data-index="${index}"]`);

            if (activePagination) {
                activePagination.classList.add('is-active');
            }

            gsap.to(all, {
                opacity: 0,
                duration: 0.2,
                onComplete: () => {

                    all.forEach(el => {
                        gsap.set(el, {
                            display: 'none',
                        });
                        el.classList.remove('is-active');
                    });

                    const activeIndexItem = section.querySelector(`.cps-index-item[data-index="${index}"]`);
                    const activeHeadingItem = section.querySelector(`.cps-heading-item[data-index="${index}"]`);
                    const activeContentItem = section.querySelector(`.cps-content-item[data-index="${index}"]`);

                    activeHeadingItem ?.classList.add('is-active');
                    activeContentItem ?.classList.add('is-active');
                    activeIndexItem ?.classList.add('is-active');

                    if (activeIndexItem) {
                        gsap.set(activeIndexItem, {
                            display: 'block',
                        });
                        gsap.fromTo(activeIndexItem, {
                            opacity: 0,
                        }, {
                            opacity: 1,
                            duration: 0.2,
                        });
                    }

                    if (activeHeadingItem) {
                        gsap.set(activeHeadingItem, {
                            display: 'block',
                        });
                        gsap.fromTo(activeHeadingItem, {
                            opacity: 0,
                            y: 10,
                        }, {
                            opacity: 1,
                            y: 0,
                            duration: 0.2,
                        });
                    }

                    if (activeContentItem) {
                        gsap.set(activeContentItem, {
                            display: 'block',
                        });
                        gsap.fromTo(
                            activeContentItem, {
                                opacity: 0,
                                y: 10,
                            }, {
                                opacity: 1,
                                y: 0,
                                duration: 0.2,
                                onComplete: () => {
                                    isAnimating = false;

                                    if (pendingDirection !== 0) {
                                        const dir = pendingDirection;
                                        pendingDirection = 0;
                                        const next = currentIndex + dir;

                                        if (next >= 1 && next <= total) {
                                            setActive(next);
                                        }
                                    }
                                },
                            },
                        );
                    } else {
                        isAnimating = false;
                    }
                },
            });
        }

        // INITIAL
        // setActive(1);

        sectionControllers.push({
            section,
            setActive,
        });

        // =========================
        // PAGINATION CLICK
        // =========================
        paginationItems.forEach(item => {
            item.addEventListener('click', () => {

                const index = parseInt(item.getAttribute('data-index'), 10);
                if (index === currentIndex) {
                    return;
                }

                const st = ScrollTrigger.getAll().find(t => t.trigger === section);
                if (!st) {
                    return;
                }

                const progress = (index - 0.5) / total;
                const scrollPosition = st.start + (st.end - st.start) * progress;

                window.scrollTo({
                    top: scrollPosition,
                    behavior: 'auto',
                });

                setActive(index);
            });
        });

        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.cps-content-item .btn');
            if (!btn) {return;}

            sessionStorage.setItem('cameFromCapabilities', '1');

            sessionStorage.setItem('capabilitiesScrollY', window.scrollY);

            // ⭐ NEW: mark as BTN navigation
            sessionStorage.setItem('capabilitiesNavType', 'btn');
        });

        document.addEventListener('click', (e) => {
            const cta = e.target.closest('a, button');
            if (!cta) {return;}

            if (cta.closest('.cps-content-item .btn')) {return;}

            const activeItem = document.querySelector('.cps-content-item.is-active');
            const index = activeItem?.getAttribute('data-index');

            sessionStorage.setItem('cameFromCapabilities', '1');
            sessionStorage.setItem('capabilitiesIndex', index);
            sessionStorage.setItem('capabilitiesScrollY', window.scrollY);

            // ⭐ NEW: mark as CTA navigation
            sessionStorage.setItem('capabilitiesNavType', 'cta');
        });

        // =========================
        // SCROLLTRIGGER
        // =========================
        ScrollTrigger.create({
            trigger: section,
            start: 'center-=60 center',
            end: `+=${total * 80}%`,
            pin: pinTarget,
            scrub: false,
            anticipatePin: 1,
            fastScrollEnd: true,

            onUpdate: (self) => {
                if (isResetting || lockScrollTrigger || document.visibilityState === 'hidden') {
                    return;
                }

                const progress = self.progress;
                const buffer = 0.12;

                let adjustedProgress = 0;

                if (progress <= buffer) {
                    adjustedProgress = 0;
                } else {
                    adjustedProgress = (progress - buffer) / (1 - buffer);
                }

                const targetIndex = Math.min(
                    total,
                    Math.max(1, Math.ceil(adjustedProgress * total)),
                );

                if (targetIndex === currentIndex) {
                    return;
                }

                const direction = targetIndex > currentIndex ? 1 : -1;

                if (isAnimating) {
                    pendingDirection = direction;
                } else {
                    pendingDirection = 0;
                    setActive(currentIndex + direction);
                }
            },
        });
    });


    // =========================
    // BACK NAVIGATION FIX
    // =========================
    window.addEventListener('pageshow', (event) => {

        const navEntries = performance.getEntriesByType('navigation');
        const isBackForward = navEntries.length && navEntries[0].type === 'back_forward';

        if (!(event.persisted || isBackForward)) {return;}

        const source = sessionStorage.getItem('cameFromCapabilities');
        if (!source) {return;}

        const navType = sessionStorage.getItem('capabilitiesNavType');

        if (navType === 'btn') {
            handleCapabilitiesBackNavigation(sectionControllers);
        } else {
            restoreCapabilitiesFromCTA(sectionControllers);
        }
    });

    function handleCapabilitiesBackNavigation(sectionControllers) {

        const cameFromCapabilities = sessionStorage.getItem('cameFromCapabilities') === '1';

        if (!cameFromCapabilities) {return;}

        sessionStorage.removeItem('cameFromCapabilities');
        const savedY = sessionStorage.getItem('capabilitiesScrollY');

        isResetting = true;

        ScrollTrigger.getAll().forEach(st => st.enable(false));
        ScrollTrigger.refresh(true);

        // ✅ restore original scroll position
        if (savedY !== null) {
            window.scrollTo({
                top: parseInt(savedY, 10),
                behavior: 'auto',
            });
        }

        sectionControllers.forEach(({
            section,
            setActive,
        }) => {

            const st = ScrollTrigger.getAll().find(t => t.trigger === section);
            if (!st) {return;}

            gsap.killTweensOf(window);

            window.scrollTo({
                top: st.start,
                behavior: 'auto',
            });

            setActive(1, true);
        });

        setTimeout(() => {
            ScrollTrigger.refresh(true);
            isResetting = false;
        }, 50);
    }

    function restoreCapabilitiesFromCTA(sectionControllers) {

        const savedY = sessionStorage.getItem('capabilitiesScrollY');
        const savedIndex = sessionStorage.getItem('capabilitiesIndex');

        isResetting = true;

        // restore scroll first
        if (savedY !== null) {
            window.scrollTo({
                top: parseInt(savedY, 10),
                behavior: 'auto',
            });
        }

        sectionControllers.forEach(({
            section,
            setActive,
        }) => {
            setActive(parseInt(savedIndex, 10), true);
        });

        setTimeout(() => {
            ScrollTrigger.refresh(true);
            isResetting = false;
        }, 50);
    }
});